import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["disabled", "onSelect", "selected", "value"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import clsx from 'clsx';
import Typography from '@mui/material/Typography';
import { styled, alpha } from '@mui/material/styles';
import { generateUtilityClasses } from '@mui/base';
import { onSpaceOrEnter } from '../internal/pickers/utils';
var classes = generateUtilityClasses('PrivatePickersMonth', ['root', 'selected']);
var PickersMonthRoot = styled(Typography)(function (_ref) {
  var theme = _ref.theme;
  return _objectSpread(_objectSpread({
    flex: '1 0 33.33%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'unset',
    backgroundColor: 'transparent',
    border: 0,
    outline: 0
  }, theme.typography.subtitle1), {}, _defineProperty({
    margin: '8px 0',
    height: 36,
    borderRadius: 18,
    cursor: 'pointer',
    '&:focus, &:hover': {
      backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity)
    },
    '&:disabled': {
      pointerEvents: 'none',
      color: theme.palette.text.secondary
    }
  }, "&.".concat(classes.selected), {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:focus, &:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  }));
});

/**
 * @ignore - do not document.
 */
var PickersMonth = function PickersMonth(props) {
  var disabled = props.disabled,
    onSelect = props.onSelect,
    selected = props.selected,
    value = props.value,
    other = _objectWithoutProperties(props, _excluded);
  var handleSelection = function handleSelection() {
    onSelect(value);
  };
  return /*#__PURE__*/React.createElement(PickersMonthRoot, _extends({
    "data-mui-test": "month",
    component: "button",
    className: clsx(classes.root, _defineProperty({}, classes.selected, selected)),
    tabIndex: disabled ? -1 : 0,
    onClick: handleSelection,
    onKeyDown: onSpaceOrEnter(handleSelection),
    color: selected ? 'primary' : undefined,
    variant: selected ? 'h5' : 'subtitle1',
    disabled: disabled
  }, other));
};
export default PickersMonth;